import React, { useEffect } from 'react';

import { getPromotionsCount, SiteConfigManager, useApplicationState } from '@atlas/core';

const PromotionsCounter = () => {
  const { authenticated } = useApplicationState();
  const [count, setCount] = React.useState(0);
  const showPromotionsCounter = SiteConfigManager.getConfig(
    'config.config.general.showPromotionsCounter',
  );

  useEffect(() => {
    if (!showPromotionsCounter) return;

    const userVisibilities = ['public', authenticated ? 'registered' : 'anonymous'];

    getPromotionsCount(userVisibilities)
      .then(({ count }) => {
        setCount(count);
      })
      .catch(() => {
        setCount(0);
      });
  }, [authenticated, showPromotionsCounter]);

  if (count === 0) {
    return null;
  }

  return <div className="header-tab-counter">{count > 99 ? '99+' : count}</div>;
};

export default PromotionsCounter;
